export const SUCCESS = 'success'
export const ERROR = 'error'

export const ALERT_UNDO_TIMEOUT = 30000
export const ALERT_DEFAULT_TIMEOUT = 7000
